import styled from 'styled-components';

export const StyledPageWrapper = styled.div`
  position: relative;
  width: 100%;
  margin: 0 auto;
  background: #ffffff;
  box-shadow: 0 -1px 0 1px #f6f6f6;
`;
